export const devVariables = {
  apiEndpoint: 'https://dev-endpoint.com',
  environmentName: 'Development Environment',
  ionicEnvName: 'dev',
  /// *** AccountController *** ///
  account_userProfile_url: 'http://mobile.axiscapital.tn/rest/api/Account/UserProfile',
  account_userAccounts_url: 'http://mobile.axiscapital.tn/rest/api/Account/UserAccounts',
  account_notification_url: 'http://mobile.axiscapital.tn/rest/api/Account/Notification',
  account_pendingNotificationsCount_url: 'http://mobile.axiscapital.tn/rest/api/Account/PendingNotificationsCount',
  account_accountBalance_url: 'http://mobile.axiscapital.tn/rest/api/Account/Balance',
  account_accountInstrumentPosition_url: 'http://mobile.axiscapital.tn/rest/api/Account/InstrumentPosition',
  account_accountInstrumentPortfolio_url: 'http://mobile.axiscapital.tn/rest/api/Account/InstrumentPositions',
  account_accountPortfolio_url: 'http://mobile.axiscapital.tn/rest/api/Account/Portfolio',
  account_accountOrderPortfolio_url: 'http://mobile.axiscapital.tn/rest/api/Account/AccountOrderPortfolio',
  account_transactionHistory_url: 'http://mobile.axiscapital.tn/rest/api/Account/TransactionHistory',
  account_notifications_url: 'http://mobile.axiscapital.tn/rest/api/Account/Notifications',

  /// *** ProcessController *** ///
  process_updateUserProfile_url: 'http://mobile.axiscapital.tn/rest/api/Process/UpdateUserProfile',
  process_changePassword_url: 'http://mobile.axiscapital.tn/rest/api/Process/ChangePassword',
  process_toggleFavoriteInstrument_url: 'http://mobile.axiscapital.tn/rest/api/Process/ToggleFavoriteInstrument',
  process_defineDefaultAccount_url: 'http://mobile.axiscapital.tn/rest/api/Process/DefineDefaultAccount',
  process_readNotification_url: 'http://mobile.axiscapital.tn/rest/api/Process/ReadNotification',
  process_cancelTradingOrder_url: 'http://mobile.axiscapital.tn/rest/api/Process/CancelTradingOrder',
  process_validateTradingOrder_url: 'http://mobile.axiscapital.tn/rest/api/Process/ValidateTradingOrder',
  process_addTradingOrder_url: 'http://mobile.axiscapital.tn/rest/api/Process/AddTradingOrder',
  process_updateTradingOrder_url: 'http://mobile.axiscapital.tn/rest/api/Process/UpdateTradingOrder',

  serverPushEndpoint: 'https://emarket.axiscapital.tn/CallBack/signalr',
  mainPushEndpoint: 'https://emarket.axiscapital.tn/CallBack/signalr',

  securityTokenEndpoint: 'http://mobile.axiscapital.tn/rest/sec/token',



  marketInstrumentsApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/Instruments',
  marketSessionApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/Session',
  marketSessionTradesApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/SessionTrades',
  marketInstrumentInfosApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/InstrumentInfos',
  marketInstrumentTransactionsApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/InstrumentTransactions',
  marketInstrumentDepthApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/InstrumentMarketDepth',
  marketInstrumentIntraDayApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/InstrumentIntraDay',
  marketInstrumentHistoryApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Market/InstrumentHistory',
  tradingOrderApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Trading/Order',
  tradingOrderBookApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Trading/TradingOrderBook',
  tradingOrderHistoryApiEndpoint: 'http://mobile.axiscapital.tn/rest/api/Trading/TradingOrderHistory',
};


// WEBPACK FOOTER //
// ./src/app/environment-variables/development.ts